<template>
  <BModal :model-value="modal" scrollable centered title="Maintenance" @update:modelValue="updateModal"> 
    <template #header>
        <div class="d-flex align-items-center justify-content-between modal-title w-100">
            <h5 class="">Maintenancce</h5>
        </div>
        <BButton
            variant="link"
            class="close"
            @click="updateModal(false)"
        >
            <i class="ion ion-android-close"></i>
        </BButton>
    </template>
      <BForm>
        <BRow>
          <BCol>
            <div class="form-group">
              <label for="">Start Date</label>
              <BFormInput type="date">
                
              </BFormInput>
            </div>
          </BCol>
          <BCol>
            <div class="form-group">
              <label for="">End Date</label>
              <BFormInput type="datetime-local">
        
              </BFormInput>
            </div>
          </BCol>
        </BRow>
        <div class="form-group">
          <BFormSelect v-model="selectType" :options="type_rooms" class="">
              <template #first>
                  <BFormSelectOption :value="null" disabled>Select type room</BFormSelectOption>
              </template>
          </BFormSelect>
        </div>
        <div class="form-group">
          <BFormSelect v-model="selectNoRoom" :options="no_rooms" class="">
              <template #first>
                  <BFormSelectOption :value="null" disabled>Select no room</BFormSelectOption>
              </template>
          </BFormSelect>
        </div>
        
        <div class="form-group">
          <BFormSelect v-model="source.selectedSource" :options="source.sources" class="">
              <template #first>
                  <BFormSelectOption :value="null" disabled>Select technician</BFormSelectOption>
              </template>
          </BFormSelect>
        </div>
        <div class="form-group" v-if="source.selectedSource == 'vendor'">
          <BFormSelect v-model="source.selectedItemSource" :options="filteredSourceItems" class="">
              <template #first>
                  <BFormSelectOption :value="null" disabled>Select technician</BFormSelectOption>
              </template>
          </BFormSelect>
        </div>
        <div class="form-group">
          <BFormSelect v-model="selectedIssue" :options="issues" class="">
              <template #first>
                  <BFormSelectOption :value="null" disabled>Select issue</BFormSelectOption>
              </template>
          </BFormSelect>
        </div>
        <div class="form-group">
          <BFormTextarea type="text" placeholder="Remark" rows="3"></BFormTextarea>
        </div>
      </BForm>
    <template #footer>
      <div class="d-flex justify-content-end">
        <BButton variant="primary" @click="submitReservation" class="mr-2">Save</BButton>
        <BButton variant="danger" @click="updateModal(false)">Cancel</BButton>
      </div>
    </template>
    </BModal>
</template>

<script>
import { ref, computed } from "vue";
import {
    BRow,
    BCol,
    BModal,
    BForm,
    BButton,
    BFormInput,
    BFormSelect,
    BFormSelectOption,
    BFormTextarea
} from "bootstrap-vue-next";

export default {
    components: {
        BRow,
        BCol,
        BModal,
        BForm,
        BButton,
        BFormInput,
        BFormSelect,
        BFormSelectOption,
        BFormTextarea
    },
    emits: ["update:modal"],
    props: {
          modal: Boolean,
    },
    setup(props, {emit}){
        console.log(props)
        const selectType = ref(null)
        const type_rooms = ref([
          
          { text: 'Deluxe'} , 
          { text: 'Super Deluxe'} , 
          { text: 'Honeymoon'} , 
          { text: 'Family'} , 
          { text: 'Studio'}
        ])
        const selectNoRoom = ref(null)
        const no_rooms = ref([
          'A1', 'A2', 'A3', 'A4', 'A5'
        ])

        const selectedIssue = ref(null)

        const issues = ref([
          'AC Rusak', 'TV Rusak', 'Toilet Rusak' 
        ])
        const source = ref({
          selectedSource: null,
          sources: [
            {
              label: 'Vendor',
              value: 'vendor'
            },
            {
              label: 'Rahmat',
              value: 'rahmat'
            },
            {
              label: 'Budi',
              value: 'budi'
            },
          ],
          selectedItemSource: null,  
          items: [
            {
              label: 'Indiehome', category: 'vendor',
            },
          ]
        })
        const updateModal = (value) => {
          emit("update:modal", value); // Sync modal state with parent
        };
        const filteredSourceItems = computed(() => {
            return source.value.items.filter(item => item.category === source.value.selectedSource)
            // return console.log(source.value.items)
        })
        return{
            updateModal,
            filteredSourceItems,
            selectedIssue,
            type_rooms,
            selectType,
            issues,
            source,
            selectNoRoom,
            no_rooms
        }
    }
}
</script>

<style>

</style>